import type { WebSocketEvents } from "utils/websockets/types";

import { useLiveUpdatesContext } from "context/liveUpdatesContext";
import { useEffect } from "react";
import { WebSocketRooms } from "utils/websockets/types";

export const useLiveUpdate = <EventData = unknown>({
  eventName,
  handleEvent,
  roomId,
  roomName = WebSocketRooms.COMPANY,
  shouldJoinRoom = true,
}: {
  eventName: WebSocketEvents;
  handleEvent: (data: EventData) => void;
  roomId?: string | string[];
  roomName?: WebSocketRooms;
  shouldJoinRoom?: boolean;
}) => {
  const { isConnected, joinRoom, socket } = useLiveUpdatesContext();

  useEffect(() => {
    if (isConnected && shouldJoinRoom) {
      if (Array.isArray(roomId)) {
        roomId.forEach((id) => {
          if (roomName) joinRoom(roomName, id);
        });
      } else if (roomId) {
        joinRoom(roomName, roomId);
      } else {
        joinRoom(roomName);
      }
      socket.on<string>(eventName, handleEvent);
    }
    return () => {
      socket.off<string>(eventName, handleEvent);
    };
  }, [eventName, isConnected, joinRoom, roomName, roomId, shouldJoinRoom, socket, handleEvent]);
};
